module.exports = __webpack_public_path__ + "blue_file.1315f0d2.svg";